const API = "/_api";
const KEY = "auxo.siteAuth.refresh";

let access = null;
let expiresAt = 0;
let user = null;
const listeners = new Set();

const emit = () => listeners.forEach((l) => l(user));

const store = (pair) => {
  access = pair.accessToken;
  expiresAt = Date.now() + pair.expiresIn * 1000;
  user = pair.user;
  try {
    localStorage.setItem(KEY, pair.refreshToken);
  } catch {}
  emit();
};

const clear = () => {
  access = null;
  expiresAt = 0;
  user = null;
  try {
    localStorage.removeItem(KEY);
  } catch {}
  emit();
};

const post = async (path, body, authHeader) => {
  const r = await fetch(API + "/auth/site/" + path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(authHeader && access ? { Authorization: "Bearer " + access } : {}),
    },
    body: JSON.stringify(body ?? {}),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw Object.assign(new Error(data.message || r.statusText), { status: r.status });
  }
  return data;
};

const refresh = async () => {
  let rt = null;
  try {
    rt = localStorage.getItem(KEY);
  } catch {}
  if (!rt) return null;
  try {
    store(await post("refresh", { refreshToken: rt }));
    return access;
  } catch {
    clear();
    return null;
  }
};

const token = async () => (access && Date.now() < expiresAt - 60000 ? access : refresh());

export const auth = {
  get user() {
    return user;
  },
  onChange(fn) {
    listeners.add(fn);
    fn(user);
    return () => listeners.delete(fn);
  },
  async init() {
    await refresh();
  },
  async login(email, password) {
    store(await post("login", { email, password }));
    return user;
  },
  async logout() {
    try {
      await post("logout", {}, true);
    } catch {}
    clear();
  },
  async fetch(url, init = {}) {
    const t = await token();
    const headers = {
      ...(init.headers || {}),
      ...(t ? { Authorization: "Bearer " + t } : {}),
    };
    if (init.body && !headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }
    let r = await fetch(url, { ...init, headers });
    if (r.status === 401 && t) {
      const n = await refresh();
      if (n) {
        r = await fetch(url, { ...init, headers: { ...headers, Authorization: "Bearer " + n } });
      }
    }
    return r;
  },
};
